import apiClient from "../api/client";
import { ENDPOINTS } from "../api/endpoints";
import { toApiCategoryValue, normalizeCategory } from "../constants/agencyCategories";
import { formatUserAddress } from "./authService";

export const fetchUsers = async (params = {}) => {
  const response = await apiClient.get(ENDPOINTS.users, { params });
  return response.data;
};

export const fetchUserById = async (id) => {
  const response = await apiClient.get(`${ENDPOINTS.users}/${id}`);
  return response.data?.data || response.data;
};

export const fetchVendors = async (page = 1, limit = 10) =>
  fetchUsers({ role: "Agent", page, limit });

export const fetchCustomers = async (page = 1, limit = 50) =>
  fetchUsers({ role: "User", page, limit });

export const createUser = async (payload) => {
  const response = await apiClient.post(ENDPOINTS.users, payload);
  return response.data;
};

export const updateUser = async (id, payload) => {
  const response = await apiClient.put(`${ENDPOINTS.users}/${id}`, payload);
  return response.data;
};

export const deleteUser = async (id) => {
  const response = await apiClient.delete(`${ENDPOINTS.users}/${id}`);
  return response.data;
};

export const formatVendorRow = (user) => ({
  id: user._id || user.id,
  name: user.name,
  email: user.email,
  phone: user.phone || user.phoneNumber || "N/A",
  address: formatUserAddress(user.address),
  joinDate: user.createdAt || user.joinDate,
  agencyCategory: normalizeCategory(user.agencyCategory),
  rating: user.rating,
  reviewsCount: user.reviewsCount,
  profileImage: user.profileImage || user.profilePhoto,
  role: user.role,
  contactperson: user.name,
});

export const formatCustomerRow = (user) => ({
  id: user._id || user.id,
  name: user.name,
  email: user.email,
  phone: user.phone || user.phoneNumber || "N/A",
  address: formatUserAddress(user.address),
  joinDate: user.createdAt || user.joinDate,
  role: user.role,
});

export const buildCreateUserPayload = ({
  name,
  email,
  phone,
  password,
  role,
  addressText,
  agencyCategory,
}) => {
  const payload = {
    name,
    email,
    phone,
    password,
    passwordConfirm: password,
    role: role === "Agent" ? "Agent" : "User",
  };

  if (addressText?.trim()) {
    payload.address = { city: addressText.trim() };
  }

  if (role === "Agent" && agencyCategory) {
    payload.agencyCategory = toApiCategoryValue(agencyCategory);
  }

  return payload;
};

export const buildUpdateUserPayload = ({
  name,
  email,
  phone,
  addressText,
  agencyCategory,
}) => {
  const payload = { name, email, phone };

  if (addressText?.trim()) {
    payload.address = { city: addressText.trim() };
  }

  if (agencyCategory) {
    payload.agencyCategory = toApiCategoryValue(agencyCategory);
  }

  return payload;
};
